/**
 * Created by alex.mccallum on 11/1/17.
 */

import { Component, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

import { SwiperComponent, SwiperDirective } from 'ngx-swiper-wrapper';

/**
 *
 * @class
 * JobsSearchResultsSlider
 *
 * @description
 * This component displays jobs in a simple mobile slider
 *
 */
@Component({
  templateUrl: './jobs-search-results-slider.component.html',
  selector: 'jobs-search-results-slider',
  styleUrls: ['./jobs-search-results-slider.component.scss'],
})
export class JobsSearchResultsSlider {

  @ViewChild(SwiperComponent) componentRef: SwiperComponent;
  @ViewChild(SwiperDirective) directiveRef: SwiperDirective;

  // Array array of job results grouped by the clicked location
  @Input() filteredJobResults: [object];
  @Input() eventName: string;

    /**
   * Gets called anytime the input properties get changed
   *
   * @param { SimpleChanges }
   */
  ngOnChanges(changes: SimpleChanges) {
    this.componentRef.directiveRef.setIndex(0, 0, true);
  }
}
